import React from 'react';
import cx from 'classnames';

import PaginationNumberField from '../PaginationNumberField';
import styles from './Pagination.module.scss';
import { PaginationProps } from './Pagination.types';
import usePresenter from './Pagination.presenter';
import { Icon, IconButton, Text } from '../../atoms';
import useBuildVariantProps from '../../../modules/theme/useBuildVariantProps';

const Pagination = (props: PaginationProps) => {
  const {
    currentPage,
    updateCurrentPage,
    nextPage,
    previousPage,
    totalPages,
    nextPageEnabled,
    previousPageEnabled,
  } = usePresenter(props);

  const previousPageIcon = props.previousPageIcon || <Icon icon="ChevronLeft" size="Small" style="Outlined" />;
  const nextPageIcon = props.nextPageIcon || <Icon icon="ChevronRight" size="Small" style="Outlined" />;

  const variantProps = useBuildVariantProps(
    "pagination",
    {
      style: "default",
    },
    {},
  );

  return (
    <div className={cx(styles.pagination, props.className)} {...variantProps}>
      <div className={styles.paginationContentContainer}>
        <IconButton
          className={styles.backButton}
          disabled={!previousPageEnabled}
          onClick={previousPage}
          icon={previousPageIcon}
          size="Small"
          style="Secondary"
          type="Ghost"
        />
        <div className={styles.paginationValuesContainer}>
          <PaginationNumberField
            className={styles.paginationNumberField}
            page={currentPage}
            totalPages={totalPages}
            onPageChanged={updateCurrentPage}
          />
          <Text
            className={styles.totalPages}
            type="BodySmall"
          >
            of {totalPages}
          </Text>
        </div>
        <IconButton
          className={styles.forwardButton}
          disabled={!nextPageEnabled}
          onClick={nextPage}
          icon={nextPageIcon}
          size="Small"
          style="Secondary"
          type="Ghost"
        />
      </div>
    </div>
  );
};

export default Pagination;
